export default __webpack_public_path__ + "media/color/ht-94827edf.svg";